// React & Hooks
import { useAuth } from "@/hooks/use-auth";
// import { useLocation, Link } from "react-router-dom";
import { Link } from "react-router-dom";
// Components
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/common/sidebar";
import { InstanceControls } from "../page-specific/Navbar/InstancePanel";

// Hooks
import { useSidebar } from "@/components/common/sidebar";
import { useLogo } from "@/hooks/use-logo";

// Icons
import {
  LayoutDashboard,
  ShieldCheck,
  TrendingUp,
  Zap,
  LogOut
} from "lucide-react";
import { SlidersHorizontal } from "lucide-react";
// import { Users } from "lucide-react"


export default function AppSidebar() {
  const { logout, isSuperuser } = useAuth();

  const items = [
    {
      title: "Overview",
      url: "/",
      icon: LayoutDashboard,
    },
    {
      title: "Hygiene",
      url: "/hygiene",
      icon: ShieldCheck,
    },
    {
      title: "Marketing Mix",
      url: "/marketing-mix",
      icon: TrendingUp,
    },
    {
      title: "Feature Adoption",
      url: "/feature-adoption",
      icon: Zap,
    },
  ];

  const userFooterItems = [
    {
      title: "Instance Setup",
      url: "/instance-setup",
      icon: SlidersHorizontal,
    },
    // {
    //   title: "User Edit",
    //   url: "/user-edit",
    //   icon: Users,
    // },
  ];

  // const location = useLocation();
  const { isMobile, toggleSidebar, state } = useSidebar();
  const handleClick = () => {
    if (isMobile) {
      toggleSidebar();
    }
  };

  return (
    <Sidebar
      collapsible="icon"
      // Sidebar colors now fully controlled by CSS vars:
      // :root -> dark sidebar, .dark -> light sidebar
      className="bg-sidebar text-sidebar-foreground"
    >
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg">
              <div className="mt-0.75 flex aspect-square size-8 items-center justify-center rounded-lg">
                <img src={useLogo()} alt="App Logo" />
              </div>
              <h4 className="font-sans text-2xl font-bold">
                <span className="text-sidebar-foreground">Audit</span>
                <span className="text-green-500">AI</span>
              </h4>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent className="text-sidebar-foreground">
        <SidebarGroup>
          <SidebarGroupContent className="space-y-4">
            {state !== "collapsed" && <InstanceControls />}
            <SidebarMenu>
              {items.map((item) => {
                // const isActive =
                //   location.pathname === item.url ||
                //   location.pathname === item.url.split("?")[0] ||
                //   location.pathname.startsWith(item.url + "/");

                return (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      asChild
                      tooltip={item.title}
                      variant="default"
                    >
                      <Link
                        to={item.url}
                        onClick={handleClick}
                        className="group-data-[collapsible=icon]:!p-[0.35rem]"
                      >
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <hr />

      <SidebarFooter className="text-sidebar-foreground">
        <SidebarMenu>
          {isSuperuser && userFooterItems.map((item) => {
            // const isActive =
            //   location.pathname === item.url ||
            //   location.pathname === item.url.split("?")[0] ||
            //   location.pathname.startsWith(item.url + "/");

            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  asChild
                  tooltip={item.title}
                  variant={"default"}
                >
                  <Link
                    to={item.url}
                    onClick={handleClick}
                    className="group-data-[collapsible=icon]:!p-[0.35rem]"
                  >
                    <item.icon />
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}

          {/* Logout – stays a simple action button */}
          <SidebarMenuItem>
            <SidebarMenuButton onClick={logout}>
              <LogOut />
              <span>Logout</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}
